import React, { useCallback, useEffect } from 'react';

import DatePickerInput from 'components/form/DatePickerInput.component';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { formatYearToDayLocalized } from 'utils/date/format.util';
import call from 'utils/functions/call.util';

const CashupDateByDay = ({ date: dateFromProps, onDateChange }) => {
  const now = new Date();

  const { val: isPickerRendered, nay: closePicker, tip: togglePicker } = useTip(false);
  const [date, setDate] = useStateWhileMounted(dateFromProps);
  const { t } = useTranslation();

  const handleChange = useCallback(
    (value) => {
      call('CashupDateByDay.onDateChange', onDateChange, value);
      setDate(value);
      closePicker();
    },
    [closePicker, onDateChange, setDate],
  );

  // NOTE: this initiates fetch and re-render of the parent Cashup component, so it will have the correct data
  useEffect(() => void call('CashupDateByDay.onDateChange', onDateChange, date), [onDateChange, date]);

  return (
    <div data-bem="CashupDateByDay" className="csh-date-wrap clearfix">
      <div className="flex-calendar-container">
        <div className="range-item">
          <label data-bem="CashupDateByDay__label" htmlFor="date" style={{ cursor: 'default' }}>
            <span data-bem="CashupDateByDay__label-text" className="dp-label">
              {t('cashUp.date')}
            </span>
            <span data-bem="CashupDateByDay__display" className="header-date" style={{ cursor: 'pointer' }} role="button" tabIndex={0} onClick={togglePicker}>
              {formatYearToDayLocalized(date)}
              <span data-bem="CashupDateByDay__icon" id="date" className="icon-date-btn" />
            </span>
          </label>
        </div>

        {isPickerRendered && (
          <div data-bem="CashupDateByDay__picker" className="day-select by-day day-select-cashup">
            <DatePickerInput
              tag="CashupDateByDay__picker"
              component={DatePickerInput.CommonDatePicker}
              inline
              selected={date}
              isShowing={isPickerRendered}
              locale="en-GB"
              onOutsideClick={closePicker}
              onChange={handleChange}
              maxDate={now}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CashupDateByDay;
